module.exports = __webpack_public_path__ + "img/2-l.7328fd48.png";